// extracted by mini-css-extract-plugin
export default {"SuggestEdit":"SuggestEdituoSX2zdYKItO","SuggestEdit-icon_arrow":"SuggestEdit-icon_arrow2WEghDVrgfBH","SuggestEdit-icon_git":"SuggestEdit-icon_git25W5-HD8uZvo"};